module.exports = __webpack_public_path__ + "static/media/wave.47ba92af.svg";